exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{body{grid-template-columns:0 100%}#add-modify-funeral-form button,#vpanel-vue-header,.bio-form .top-bar,.sidebar-nav,.vp-tab-nav{display:none!important}.form-control{border-width:1px;border-color:#ced4da}}.vp-tab-nav+.bio-form{padding:1rem}.vp-tab-nav+.bio-form h4{margin-top:0}.vp-tab-nav+.bio-form .dynamic-sections,.vp-tab-nav+.bio-form .dynamic-sections>:first-child{margin:0}", ""]);

// exports
